import React, {Component} from 'react';
import Page from '../containers/page';
import {
    Col,
    Container,
    Row
} from 'reactstrap';
import image from '../assets/images/account-cover.png';
import imageMobile from '../assets/images/account-cover.png';
import StockConfigForm from "../components/forms/stockConfigForm";
import {API_ENDPOINT} from "../constants";

class IntegrationGuidePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            activeTab: null,
            stockConfig: null,
            error: null,
        };
    }

    toggleTab(index) {
        this.setState({activeTab: this.state.activeTab === index ? null : index});
    }

    async componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        this.get();
    }

    submit = (data) => {
        console.log(data);

        let obj = {};

        if (data.email) {
            obj.email = {
                to: data.email.to,
            };

            if (data.email.format == 'xlsx') {
                obj.email.xlsx = {
                    skus: data.email.skus,
                    filename: data.email.filename,
                    template: data.email.template,
                    schedule: data.email.schedule,
                };
            } else if (data.email.format == 'csv') {
                obj.email.csv = {
                    skus: data.email.skus,
                    filename: data.email.filename,
                    template: data.email.template,
                    schedule: data.email.schedule,
                };
            }
        }
        if (data.ftp) {
            obj.ftp = {
                host: data.ftp.host,
                port: data.ftp.port,
                username: data.ftp.username,
                password: data.ftp.password,
                secure: data.ftp.secure ? true : false,
                secureOptions: data.ftp.secureOptions,
            };

            if (data.ftp.format == 'xlsx') {
                obj.ftp.xlsx = {
                    skus: data.ftp.skus,
                    filename: data.ftp.filename,
                    template: data.ftp.template,
                    schedule: data.ftp.schedule,
                };
            } else if (data.ftp.format == 'csv') {
                obj.ftp.csv = {
                    skus: data.ftp.skus,
                    filename: data.ftp.filename,
                    template: data.ftp.template,
                    schedule: data.ftp.schedule,
                };
            }
        }

        if (data.sftp) {
            obj.sftp = {
                host: data.sftp.host,
                port: data.sftp.port,
                username: data.sftp.username,
                password: data.sftp.password,
            };

            if (data.sftp.format == 'xlsx') {
                obj.sftp.xlsx = {
                    skus: data.sftp.skus,
                    filename: data.sftp.filename,
                    template: data.sftp.template,
                    schedule: data.sftp.schedule,
                };
            } else if (data.sftp.format == 'csv') {
                obj.sftp.csv = {
                    skus: data.sftp.skus,
                    filename: data.sftp.filename,
                    template: data.sftp.template,
                    schedule: data.sftp.schedule,
                };
            }
        }

        fetch(API_ENDPOINT + '/account/stock-list', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(obj),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.error) {
                    this.setState({error: result.error});
                } else {
                    //this.props[0].history.push('/account')
                    this.setState({
                        done: true,
                    });
                }
            });
    };
    get = () => {
        fetch(API_ENDPOINT + '/account/stock-list', {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((result) => {
                this.setState({
                    stockConfig: result,
                });
            });
    };

    render() {
        return (
            <div className="account-page">
                <section className="test">
                    <img
                        src={
                            typeof window !== 'undefined' && window.innerWidth < 768
                                ? imageMobile
                                : image
                        }
                        alt="Integration Cover"
                    />
                    <div className="test-content">
                        <h1>{'INTEGRATION GUIDE'.translate(this.props.lang)}</h1>
                    </div>
                </section>

                <Container>
                    <Row>
                        <Col lg="12">
                            <div className="integration-guide-container">
                                <p className="sub-title">
                                    {'Thank you for choosing Venture Design as your distributor. We believe that we will have a successful cooperation in the near future.\n' +
                                        'To that end, we\'ve created this integration guide and tailored it to our different customer groups. Choose the group you belong to and\n' +
                                        'follow further instructions. If you have additional questions, please contact: simon.lijledahl@venturedesign.se'.translate(this.props.lang)}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container>
                    <Row>
                        <Col lg="12" className="integration-guide-accordion">
                            <div className="accordion-wrapper">
                                {/* === Accordion 1 === */}
                                <div className={`accordion-item ${this.state.activeTab === 0 ? 'active' : ''}`}>
                                    <div className="accordion-header" onClick={() => this.toggleTab(0)}>
                                        <span className="accordion-title">For customers who can use our API</span>
                                        <span className={`arrow ${this.state.activeTab === 0 ? 'open' : ''}`}>
                                          <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                          >
                                            <polyline points="6 9 12 15 18 9"/>
                                          </svg>
                                        </span>
                                    </div>
                                    {this.state.activeTab === 0 && (
                                        <div className="accordion-body" style={{height: '100vh'}}>
                                            <iframe
                                                width="100%"
                                                height="100%"
                                                id="briqpay-iframe"
                                                title="API Docs"
                                                allow="payment"
                                                src="https://api.venturedesign.se/api-docs/"
                                            ></iframe>
                                        </div>
                                    )}
                                </div>

                                {/* === Accordion 2 === */}
                                <div className={`accordion-item ${this.state.activeTab === 1 ? 'active' : ''}`}>
                                    <div className="accordion-header" onClick={() => this.toggleTab(1)}>
                                        <span className="accordion-title">For customers who cannot use our API</span>
                                        <span className={`arrow ${this.state.activeTab === 1 ? 'open' : ''}`}>
                                          <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                          >
                                            <polyline points="6 9 12 15 18 9"/>
                                          </svg>
                                        </span>
                                    </div>
                                    {this.state.activeTab === 1 && (
                                        <div className="accordion-body">
                                            <section className="faq-section">
                                                <h4>1) HOW DO I GET PRODUCT DATA AND IMAGES?</h4>
                                                <p>
                                                    In the folder "Standardfile FTP" on our FTP, every day we
                                                    put a file called "Standardfile.xlsx".
                                                    In that file you will find all the information about the products
                                                    and links to their images.
                                                </p>

                                                <h4>Our FTP access details are:</h4>
                                                <ul>
                                                    <li><strong>Host:</strong> 162.55.247.33</li>
                                                    <li><strong>Username:</strong> pim@venturedesign.se</li>
                                                    <li><strong>Password: </strong>{'hR-I5S@k{xyO'}</li>
                                                    <li><strong>Port:</strong> 21</li>
                                                </ul>

                                                <p>
                                                    If you need individual images in high resolution, you can find them
                                                    in our image bank at the following link:
                                                    <br/>
                                                    <a
                                                        href="https://bildbank.venturedesign.se/o/rl8j3dubudx4to37v9oos9mjphxbdbj8cpo8uz0/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        https://bildbank.venturedesign.se/o/rl8j3dubudx4to37v9oos9mjphxbdbj8cpo8uz0/
                                                    </a>
                                                </p>
                                            </section>

                                            <section className="faq-section">
                                                <h4>2) HOW DO I GET STOCK STATUS?</h4>
                                                <p>
                                                    We send the stock status automatically either to your email or to
                                                    your FTP / SFTP. Please select one of the methods first and then
                                                    fill in the other options as well.
                                                </p>

                                                <div className="account-container"
                                                     style={{paddingLeft: 2, paddingBottom: 2}}>
                                                    {this.state.stockConfig ? (
                                                        <StockConfigForm
                                                            lang={this.props.lang}
                                                            initialValues={this.state.stockConfig}
                                                            onSubmit={this.submit}
                                                        />
                                                    ) : null}
                                                    {this.state.error ? <p>{this.state.error}</p> : null}
                                                    {this.state.done ? (
                                                        <p>
                                                            {'Din förfrågan har skickats. Om du inte får en lagerstatus, vänligen kontakta oss på: igor@venturedesign.se'.translate(
                                                                this.props.lang,
                                                            )}
                                                        </p>
                                                    ) : null}
                                                </div>
                                            </section>

                                            <section className="faq-section">
                                                <h4>3) HOW DO I PLACE ORDERS?</h4>
                                                <p>Ordering is done through our website.</p>
                                            </section>

                                            <section className="faq-section">
                                                <h4>4) HOW DO I GET AN ORDER CONFIRMATION?</h4>
                                                <p>
                                                    When you have completed your purchase on our website, the system
                                                    will automatically send you an order confirmation to the email you
                                                    provided during registration.
                                                </p>
                                            </section>

                                            <section className="faq-section">
                                                <h4>5) HOW DO I GET THE LINK TO TRACK THE SHIPMENT?</h4>
                                                <p>
                                                    When the goods you ordered leave our warehouse, the system will
                                                    automatically send you or your customer (depending on your selection
                                                    at checkout) an email with a link to track the shipment.
                                                </p>
                                            </section>

                                            <section className="faq-section">
                                                <h4>6) HOW DO I MAKE A COMPLAINT?</h4>
                                                <p>You can find all the necessary information on "MY PAGES" on our
                                                    website.</p>
                                            </section>

                                            <section className="faq-section">
                                                <h4>7) HOW DO I RETURN GOODS?</h4>
                                                <p>You can find all the necessary information on "MY PAGES" on our
                                                    website.</p>
                                            </section>
                                            <section className="faq-section">
                                                <hr className="faq-divider"/>
                                                <div className="faq-shortcut">
                                                    <h4>IS THERE AN EASIER WAY OF INTEGRATION?</h4>
                                                    <p>
                                                        YES! Click here:
                                                        <a
                                                            href="https://venturedesign.se/stedger"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            https://venturedesign.se/stedger
                                                        </a>
                                                    </p>

                                                </div>
                                            </section>
                                        </div>

                                    )}


                                </div>

                                {/* === Accordion 3 === */}
                                <div className={`accordion-item ${this.state.activeTab === 2 ? 'active' : ''}`}>
                                    <div className="accordion-header" onClick={() => this.toggleTab(2)}>
                                        <span className="accordion-title">For customers using Shopify</span>
                                        <span className={`arrow ${this.state.activeTab === 2 ? 'open' : ''}`}>
                                          <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                          >
                                            <polyline points="6 9 12 15 18 9"/>
                                          </svg>
                                        </span>
                                    </div>
                                    {this.state.activeTab === 2 && (
                                        <div className="accordion-body">
                                            <section className="faq-section">
                                                <h4>Shopify Integration – Automatic Synchronization</h4>
                                                <p>
                                                    This integration enables seamless synchronization of products with
                                                    your Shopify store.
                                                    It supports bulk imports, price management and inventory updates,
                                                    directly from our system.
                                                </p>
                                            </section>

                                            <section className="faq-section">
                                                <h3>What We Need From You</h3>
                                                <p>
                                                    To enable the integration, please provide the following information
                                                    from your Shopify store.
                                                    Below each item are instructions on how to locate or generate it.
                                                </p>
                                                <p>
                                                    <strong>Once you’ve gathered the required information, please send
                                                        it to:</strong>{' '}
                                                    <a href="mailto:igor@venturedesign.se">igor@venturedesign.se</a>
                                                </p>

                                                <h4>1. Store Name (Shopify Domain)</h4>
                                                <p>The full domain of your Shopify store.</p>
                                                <p>Example:example-store.myshopify.com</p>

                                                <h4>2. Private App Access Token (Admin API Access Token)</h4>

                                                <p>This token allows secure access to your store via the Shopify Admin
                                                    API.</p>
                                                <p><strong>How to generate it:</strong></p>
                                                <ul>
                                                    <li>Log in to the Shopify admin panel.</li>
                                                    <li>Navigate to <em>Apps → Develop apps</em>.</li>
                                                    <li>Select an existing app or create a new one.</li>
                                                    <li>In the <em>Configuration</em> section, enable these API scopes:
                                                    </li>
                                                    <ul>
                                                        <li>read_products</li>
                                                        <li>write_products</li>
                                                        <li>read_inventory</li>
                                                        <li>write_inventory</li>
                                                        <li>(Optional) read_price_rules, write_price_rules</li>
                                                    </ul>
                                                    <li>Install the app and copy the Admin API access token.</li>
                                                </ul>
                                                <p>Example: shpat_xxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>

                                                <h4>3. Location ID (Shopify Inventory Location)</h4>
                                                <p>This is the unique ID of the inventory location used for stock
                                                    updates.</p>
                                                <p><strong>How to find it:</strong></p>
                                                <ul>
                                                    <li>Go to <em>Shopify admin → Settings → Locations</em>.</li>
                                                    <li>Click on your preferred location.</li>
                                                    <li>The Location ID appears in the URL (e.g.,
                                                        /locations/<strong>12345678</strong>) or can be retrieved via
                                                        the Shopify API.
                                                    </li>
                                                </ul>

                                                <h4>4. Product Inventory Setting</h4>
                                                <p>Ensure that all products you wish to sync have inventory tracking
                                                    enabled.</p>
                                                <p><strong>How to check:</strong></p>
                                                <ul>
                                                    <li>Open a product in your Shopify admin.</li>
                                                    <li>Go to the <em>Inventory</em> section.</li>
                                                    <li>Make sure the <em>Track quantity</em> option is enabled.</li>
                                                </ul>
                                            </section>

                                            <section className="faq-section">
                                                <h3>What This Integration Supports</h3>

                                                <h4>1. CSV Bulk Product Import</h4>
                                                <p>
                                                    We can provide you with a preformatted CSV file to perform bulk
                                                    import of products via Shopify.
                                                </p>
                                                <ul>
                                                    <li>Go to <em>Products → Import</em></li>
                                                    <li>Click <strong>Add file</strong> and select your CSV</li>
                                                    <li>Click <strong>Upload and continue</strong></li>
                                                    <li>Confirm field mapping and click <strong>Import products</strong>
                                                    </li>
                                                </ul>
                                            </section>


                                            <section className="faq-section">
                                                <h4>2. Automatic Price Update (optional)</h4>
                                                <p>
                                                    Our integration also supports automatic product price updates on
                                                    Shopify based on your price list.
                                                </p>
                                                <p><strong>How it works:</strong></p>
                                                <ul>
                                                    <li>We match the product by SKU in your price list.</li>
                                                    <li>VAT is added if defined</li>
                                                    <li>You can optionally define a percentage markup (e.g., 10%).</li>
                                                    <li>The final price is calculated and sent to Shopify as the product
                                                        price.
                                                    </li>
                                                </ul>
                                                <p><strong>Example:</strong> If the base price is 100 SEK + 25% VAT =
                                                    125 SEK, and you apply a 10% markup, the final price in Shopify will
                                                    be 137.5 SEK.</p>
                                            </section>
                                            <section className="faq-section">
                                                <h4>3. Automatic Inventory Updates </h4>
                                            </section>

                                        </div>
                                    )}


                                    {/*                   {this.state.activeTab === 2 && (
                                        <div className="accordion-body">
                                            <p>Instructions for installing our Shopify App and connecting it with your
                                                Venture Design account.</p>
                                             Add Shopify guide content here
                                        </div>
                                    )}*/}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>


            </div>
        );
    }
}

export default Page(IntegrationGuidePage);
